import { useRandomId } from "common/hooks/useRandomId";
import React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import { FieldError } from "./FieldError";
import { Label } from "./Label";
import styles from "./TextField.module.css";

interface Props {
  title: string;
  value?: string;
  placeholder?: string;
  fieldProps: UseFormRegisterReturn;
}

export const Field: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const id = useRandomId();
  return (
    <>
      <Label htmlFor={id} title={props.title} />
      <input
        className={styles.input}
        id={id}
        value={props.value}
        placeholder={props.placeholder}
        {...props.fieldProps}
      />
      <FieldError name={props.fieldProps.name} />
    </>
  );
};
